import { __ } from '~/locale';

export const MORE_ACTIONS_TEXT = __('More actions');

export const NAME_SORT_FIELD = { orderBy: 'NAME', label: __('Name') };

export const PUBLISHED_SORT_FIELD = { orderBy: 'PUBLISHED_AT', label: __('Published') };
